module.exports = __webpack_public_path__ + "static/media/lateralhead_mild_right.9bf2e015.png";